import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { useTooltip } from '@frontend/design-system';

type Props = {
  text: string;
  style?: React.CSSProperties;
};

export const InfoHoverIcon = ({ text, style }: Props) => {
  const { triggerProps, tooltipProps, Tooltip } = useTooltip({
    placement: 'top',
  });

  return (
    <div {...triggerProps} style={style}>
      <Icon color='subdued' name='info-small' style={{ minWidth: theme.spacing(2) }} />
      <Tooltip {...tooltipProps} style={{ ...tooltipProps.style, maxWidth: '220px' }}>
        {text}
      </Tooltip>
    </div>
  );
};
